import React, {
  forwardRef,
  useCallback,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import Styles from './styles.module.sass'


/**
 * N.B.: **This is a controlled component**: it does not maintain its own state.
 *
 * @returns {Node}
 */
export default forwardRef(Input)

function Input({ className, disabled, handleChange, handleFocus, ...props }, ref) {
  const onChange = useCallback((e) => {
    if ( disabled ) {
      return
    }

    e.stopPropagation()

    const {
      name,
      value,
    } = e.target

    handleChange({
      name,
      value,
    })
  }, [disabled, handleChange])

  const onFocus = useCallback((e) => {
    if ( disabled || !handleFocus ) {
      return
    }

    e.stopPropagation()

    handleFocus()
  }, [disabled, handleFocus])

  const rootClassName = classnames(Styles.root, className)

  return (
    <input
      className={ rootClassName }
      disabled={ disabled }
      onChange={ onChange }
      onFocus={ onFocus }
      ref={ ref }
      { ...props }
    />
  )
}

Input.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,

  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleFocus: PropTypes.func,
  name: PropTypes.string,
  type: PropTypes.oneOf([
    'color',
    'date',
    'datetime-local',
    'email',
    'file',
    'hidden',
    'month',
    'number',
    'password',
    'range',
    'tel',
    'text',
    'time',
    'url',
    'week',
  ]),
}

Input.defaultProps = {
  type: 'text',
  // This keeps React from whining about switching from an uncontrolled
  // to a controllled component
  value: '',
}
